// @flow

import * as React from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';

import {
  addCartProduct,
  getCart,
  selectCartIsWorking,
  selectCartUUID,
  updateCartProduct,
} from '@gandi/cart';
import { notifyDanger } from '@gandi/notifications';

import type { FullState, Dispatch } from '../../../../types';
import { withImages } from '../../../modules/images';
import { withRegions } from '../../../modules/regions';
import { withTemplates } from '../../../modules/templates';

import Presenter, { type PresenterProps } from './Presenter';

const mapStateToProps = (state: FullState, ownProps: PresenterProps) => {
  const datacenter = ownProps.formValues.datacenter;

  return {
    datacenters: ownProps.regions?.map(region => region.datacenters).flat(),
    datacenterImages: ownProps.images?.filter(image => {
      if (datacenter && image.datacenters.indexOf(datacenter) === -1) {
        return false;
      }
      return true;
    }),
    isLoaded:
      ownProps.isLoadedRegions &&
      ownProps.isLoadedTemplates &&
      ownProps.isLoadedImages,
    isFetching:
      ownProps.isFetchingRegions ||
      ownProps.isFetchingTemplates ||
      ownProps.isFetchingImages,
    isFailure:
      ownProps.isFailureRegions ||
      ownProps.isFailureTemplates ||
      ownProps.isFailureImages,

    cartIsWorking: selectCartIsWorking(state),
    cartId: selectCartUUID(state),
  };
};

// XXX: refactor as simple object, e.g. `const mapDispatchToProps = { addCartProduct, fetchDatacenters … }
const mapDispatchToProps = (dispatch: Dispatch) => ({
  addCartProduct: (...args: any) => dispatch(addCartProduct(...args)),
  getCart: (...args: any) => dispatch(getCart(...args)),
  notifyDanger: (...args: any) => dispatch(notifyDanger(...args)),
  updateCartProduct: (...args: any) => dispatch(updateCartProduct(...args)),
});

export default (compose(
  withImages,
  withRegions,
  withTemplates,
  connect(mapStateToProps, mapDispatchToProps),
)(Presenter): React.ComponentType<{ ... }>);
